angular.module("questionarioAdv.module")
  .component("noteQuestionario", {
    templateUrl: "ng/components/questionarioAdv/noteQuestionario/noteQuestionario.view.html",
    bindings: {
      model: "=",
      exportValidationComponent: '&',
      allModelQuestionario: '<',
      checkVisibleField: '<',
      responseQuestionario: '<',
      leasingData: '<',
      externalLink: '<'
    },
    controllerAs: 'noteQuestionarioCtrl',
    controller: NoteQuestionario
  })

function NoteQuestionario(
  $scope,
  $timeout,
  $uniService,
  $portalService
) {
  var self = this;

  self.$onInit = function () {
    self.isAra = $portalService.isAra()
    self.documentDate = {
      disabledDays: [0],
      disabledDates: [
        "01-01",
        "06-01",
        "25-04",
        "01-05",
        "02-06",
        "15-08",
        "01-11",
        "08-12",
        "25-12",
        "26-12"
      ]
    }
    self.supportModel = {
      noteCommon: {
        analisiComportamento: null
      },
      esecutoriKo: []
    }
    setDefaulValue();
    validateComponent();

    if (self.model.noteCommon.warningEsecutori && self.model.noteCommon.warningEsecutori.listaEsecutoriKo && self.model.noteCommon.warningEsecutori.listaEsecutoriKo.length) {
      self.supportModel.esecutoriKo = self.model.noteCommon.warningEsecutori.listaEsecutoriKo;
    }

  }

  self.$onChanges = function (changed) {
    if (changed.checkVisibleField && typeof changed.checkVisibleField.currentValue != "undefined") {
      if (!$portalService.isAru()) {
        callGetIdentificatoriAdvNote();
      }
      checkFieldIsVisible();
      validateComponent();
    }
  }

  self.handleChangeClassicVersion = function (name, value) {

    switch (name) {
      case 'noteCommonDataSottoscrizione':
        self.model.noteCommon.dataSottoscrizione = value;
        break;

      default:
        break;
    }
    validateComponent();
  }

  var validateComponent = function () {
    $timeout(function () {
      console.log("Il form noteQuestionario è:", $scope.noteQuestionario.$valid);

      self.exportValidationComponent({
        valid: $scope.noteQuestionario.$valid
      })

    }, 500)
  }

  self.handleChange = function (tipoNota, sezioneNota, valueSelected) {
    self.model[tipoNota][sezioneNota].forEach(function (element) {
      if (element.value == valueSelected.value) {
        element.selected = true;
      } else {
        element.selected = false;
      }
    })

    validateComponent();
  }

  var setDefaulValue = function () {
    self.supportModel.noteCommon.analisiComportamento = self.model.noteCommon && self.model.noteCommon.analisiComportamento &&
      self.model.noteCommon.analisiComportamento.find(function (element) {
        return element.selected == true;
      })
  }

  var checkFieldIsVisible = function () {
    var tempVar = self.allModelQuestionario.intro.finalita.find(function (element) {
      return element.value == "2"
    })
    self.visibleField = tempVar && tempVar.selected

    self.hideCompilatoreAlba = self.allModelQuestionario.intro &&
      self.allModelQuestionario.intro.modalita.some(x => { return x.name == 'PRELIM' })
  }

  var callGetIdentificatoriAdvNote = function () {
    if (self.responseQuestionario.contratto && self.responseQuestionario.modulo) {


      $uniService.getIdentificatoriAdvNote(self.responseQuestionario.contratto, self.responseQuestionario.modulo)
        .then(function (response) {
          console.log(response);
        })
        .catch(function (error) {
          console.log(error);
        })
    } else if (self.leasingData && self.leasingData.id) {

      $uniService.getIdentificatoriAdvNote(null, null, self.leasingData.id)
        .then(function (response) {
          console.log(response);
        })
        .catch(function (error) {
          console.log(error);
        })
    }
  }
}